import { FC } from 'react'
import classNames from 'classnames'

import { CarouselContainerProps } from './types'
import { twMerge } from 'tailwind-merge'

// TODO: add will-change-transform	transform-gpu when autoscroll plugin is used
export const Container: FC<CarouselContainerProps> = ({
  className,
  ...props
}) => <ul className={twMerge('grid grid-flow-col ', className)} {...props} />
